import React, { useEffect, useMemo, useState } from "react";
import { Flower2, Waves } from "lucide-react";
import ChatCore from "../../shared/chat/ChatCore";

function SeekerEmptyState() {
    return (
        <div className="h-full flex flex-col items-center justify-center text-center p-8 bg-gradient-to-b from-sky-50/70 to-indigo-50/70 dark:from-gray-900 dark:to-gray-950">
            <div className="relative mb-6">
                <div className="absolute -inset-4 rounded-full bg-sky-200/40 dark:bg-sky-900/20 blur-2xl" />
                <div className="relative w-24 h-24 rounded-full bg-white/80 dark:bg-gray-800/80 border border-sky-100 dark:border-gray-700 flex items-center justify-center shadow-sm">
                    <Flower2 className="w-10 h-10 text-sky-500" />
                </div>
            </div>
            <h2 className="text-2xl font-display font-bold text-gray-800 dark:text-gray-100 mb-2">Welcome back</h2>
            <p className="text-gray-600 dark:text-gray-300 max-w-md leading-relaxed">
                Take a deep breath. You are safe to share here.
            </p>
        </div>
    );
}





export default function ChatSeeker() {
    const [isFocusMode, setIsFocusMode] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isVentMode, setIsVentMode] = useState(false);
    const isFocusModeActive = isFocusMode;

    useEffect(() => {
        if (isFocusModeActive) {
            setIsDrawerOpen(false);
        }
    }, [isFocusModeActive]);



    return (
        <div className="relative h-full">
            <ChatCore
                activeRole="SEEKER"
                canRateProvider={true}
                showEmotionRing={!isFocusMode}
                fetchSuggestionsEnabled={true}
                isFocusMode={isFocusMode}
                onFocusModeChange={setIsFocusMode}
                customEmptyState={<SeekerEmptyState />}
                customInputAddons={null}
                isVentMode={isVentMode}
            />
        </div>
    );
}
